import React from 'react';
import { Link, browserHistory } from 'react-router';
import { toast } from 'react-toastify';
import { isSubsValid } from '../actions/utils';

const ONE_DAY = 1000 * 60 * 60 * 24;
const DAYS_SHOW = 2;

const Close = ({ onClick }) => (
  <div>
    <button type="button" className="btn btn-link btn-lg" onClick={onClick}>
      ✖
    </button>
  </div>
);

const ToastMessage = ({ title, text, days, onClick }) => (
  <div>
    <h3>
      {title}
      {days && <b> {`${days} ${days > 1 ? 'дня' : 'день'}`} </b>}
    </h3>

    <br />
    <Link
      className="btn btn-dark-green btn-small text-uppercase"
      to="/i/plan"
      onClick={onClick}
    >
      Купить подписку
    </Link>
  </div>
);

const isShop = location =>
  location.startsWith('/i/plan') ||
  location.startsWith('/i/buy') ||
  location.startsWith('/i/offer');

class SubscribitionReminder extends React.Component {
  state = {
    reminderClosed: false
  };

  addToast = (message, callback) => {
    if (
      !toast.isActive(this.toastId) &&
      (!this.lastToast ||
        new Date().getTime() - this.lastToast.getTime() > 1000)
    ) {
      this.lastToast = new Date();
      this.toastId = toast.warn(message, {
        position: 'bottom-center',
        autoClose: false,
        hideProgressBar: true,
        draggable: true,
        closeButton: <Close onClick={() => callback(true)} />
        /* onClose: () => callback() */
      });
    }
  };

  closeReminder = closeClicked => {
    if (
      !closeClicked &&
      !this.state.reminderClosed &&
      this.props.user &&
      !isShop(this.props.location)
    ) {
      browserHistory.push('/i/plan');
    }

    this.setState({ reminderClosed: true });
  };

  showReminder = (user, location) => {
    const isNotShop = !isShop(location);
    if (user && user.subs && !this.state.reminderClosed && isNotShop) {
      const currentDate = new Date(),
        validDate = new Date(user.subs.valid);

      //user activated trial subs
      if (user.subs.source === 'trial' && user.subs.lessons === 0) {
        if (currentDate < validDate) {
          //still active
          const days = Math.round(
            (validDate.getTime() - currentDate.getTime()) / ONE_DAY
          );

          if (days > 0) {
            if (days <= DAYS_SHOW) {
              this.addToast(
                <ToastMessage
                  title="Ваша подписка закончится через "
                  days={days}
                  onClick={this.closeReminder}
                />,
                this.closeReminder
              );
            }
          } else {
            this.addToast(
              <ToastMessage
                title="Ваша пробная подписка истекает сегодня!"
                onClick={this.closeReminder}
              />,
              this.closeReminder
            );
          }
        } else {
          //expired
          this.addToast(
            <ToastMessage
              title="Ваша пробная подписка истекла"
              onClick={this.closeReminder}
            />,
            this.closeReminder
          );
        }
      }

      if (!isSubsValid(user) && user.subs.plan) {
        //paid subs expired
        this.addToast(
          <ToastMessage
            title="Ваша подписка истекла"
            onClick={this.closeReminder}
          />,
          this.closeReminder
        );
      }
    }
  };

  componentDidMount() {
    this.showReminder(this.props.user, this.props.location);
  }

  componentWillReceiveProps(newProps) {
    if (this.props.location !== newProps.location) {
      this.timer = setTimeout(
        this.showReminder(newProps.user, newProps.location),
        1500
      );
    }

    if (isShop(newProps.location) && typeof this.toastId !== 'undefined') {
      toast.dismiss(this.toastId);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
    toast.dismiss(this.toastId);
  }

  render() {
    return null;
  }
}

export default SubscribitionReminder;
